frappe.ready(() => {
    // Charger le Webchat Botpress
    const script1 = document.createElement('script');
    script1.src = "https://cdn.botpress.cloud/webchat/v2.2/inject.js";
    document.head.appendChild(script1);
  
    const script2 = document.createElement('script');
    script2.src = "https://files.bpcontent.cloud/2024/10/31/08/20241031080215-IQ87348T.js";
    document.head.appendChild(script2);
  
    // Attendre que le script soit chargé et initialiser le chat
    script1.onload = () => {
      window.botpressWebChat.init({
        composerPlaceholder: "Posez-moi une question...",
        clientId: "4d6ebea8-56ba-4714-8aa8-dc199447b747", // Remplace par ton Client ID
        host: "https://cdn.botpress.cloud/webchat",
        container: "#chat-container",
        showCloseButton: false,
        hideWidget: true
      });
    };
  
    // Ajouter une bulle de chat personnalisée
    const chatBubble = document.createElement('div');
    chatBubble.id = "chat-bubble";
    
    document.body.appendChild(chatBubble);
  
    // Conteneur du chat
    const chatContainer = document.createElement('div');
    chatContainer.id = "chat-container";
    chatContainer.style = "display:none;position:fixed;bottom:80px;right:20px;width:350px;height:500px;background:white;border:1px solid #ccc;box-shadow:0 4px 6px rgba(0,0,0,0.1);border-radius:10px;overflow:hidden;z-index:1000;";
    document.body.appendChild(chatContainer);
  
    // Afficher/Masquer le chat
    chatBubble.addEventListener('click', () => {
      chatContainer.style.display = chatContainer.style.display === "none" ? "block" : "none";
    });
  });
  